<div class="custella-modal">
    <form [formGroup]="addTaskFullForm">
        <div class="custella-modal-header align-items-center">
            <div>
                <div class="text-14 font-medium" *ngIf="mode === 'add'" id="title_TaskNew">
                    <span>{{ translate?.task.sections.sec6.singular }}</span>
                </div>
                <div class="text-14 font-medium" *ngIf="mode === 'edit'" id="title_TaskEdit">
                    <span>{{ translate?.task.sections.sec3.singular }}</span>
                </div>
            </div>
           
            <i class="pi pi-times" id="btn_TaskClose" (click)="modalRef.hide()" [pTooltip]="translate?.general.buttons.close.singular" tooltipPosition="left"></i>
        </div>

        <div class="">
            <!-- Container -->
            <div class="custella-form-container position-relative d-block w-100 rounded-2 m-0 pt-3" style="height: fit-content;">
                <!-- Container Content -->
                    <!-- Task name and Priority level -->
                    <div class="custella-form-container-content m-0">
                        <div class="custella-content-row mb-3 pe-0">
                            <div class="custella-content-row-input col-12">
                                <span class="custella-content-row-input-title mandatory" id="label_TaskName">{{ translate?.task.fields.taskName.singular }}</span>
                                <input pInputText autocomplete="off" type="text" id="input_TaskNameField" [(ngModel)]="addTask.taskName" formControlName="name" name="name" />
                                <div class="p-error text-10" *ngIf="addTaskFullForm.controls['name'].touched && addTaskFullForm.controls['name'].invalid">
                                    <span *ngIf="addTaskFullForm.controls['name'].errors?.required" id="label_TaskNameReqField">{{ translate?.general.validationFE.requiredField }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- my focus starts here -->
                        <div class="custella-time-content mt-1">
                            <!-- Time fields -->
                            <div class="custella-content-row pe-0 mb-3">
                                <div class="d-flex col">
                                    <div class="custella-content-row-input col-5">
                                        <span class="custella-content-row-input-title" id="label_TaskDate">{{ translate?.task.fields.date.singular }}</span>
                                        <span class="p-input-icon-right w-100">
                                            <i class="pi pi-calendar" style="z-index: 1;" (click)="openCalendar()"></i>
                                            <p-calendar  #calendar baseZIndex="10000" dateFormat="dd/mm/yy" yearRange="2000:2030" id="picklist_TaskDateField" [(ngModel)]="addTask.date" formControlName="date" name="date" [placeholder]="translate?.general.messages.none" [yearNavigator]="true" appendTo="body"></p-calendar>
                                        </span>
                                        <div class="p-error text-10" *ngIf="addTaskFullForm.controls['date'].touched && addTaskFullForm.controls['date'].invalid">
                                            <span *ngIf="addTaskFullForm.controls['date'].errors?.required" id="label_TaskDateReqField">{{ translate?.general.validationFE.requiredField }}</span>
                                        </div>
                                    </div>
                                    <ng-container>
                                        <div class="custella-content-row-input col me-0">
                                            <span class="custella-content-row-input-title" id="label_TaskStartTime">{{ translate?.task.fields.startTime.singular }}</span>
                                            <span class="p-input-icon-right w-100">
                                                <i class="pi pi-clock" style="z-index: 1;" (click)="openStarTime()"></i>
                                                <p-calendar #starTime id="picklist_TaskStartTimeField" hourFormat="12" [placeholder]="translate?.general.messages.none" [timeOnly]="true" (ngModelChange)="changeEndTime()" [(ngModel)]="addTask.startTime" formControlName="startTime" name="startTime" appendTo="body"></p-calendar>
                                            </span>
                                            <div class="p-error text-10" *ngIf="addTaskFullForm.controls['startTime'].touched && addTaskFullForm.controls['startTime'].invalid">
                                                <span *ngIf="addTaskFullForm.controls['startTime'].errors?.required" id="label_TaskStartTimeReqField">{{ translate?.general.validationFE.requiredField }}</span>
                                            </div>
                                        </div>
                                        <div class="custella-content-row-input mx-2" style="margin-top: 30px;">
                                            <span id="label_TaskToTime">{{ translate?.task.fields.to.singular }}</span>
                                        </div>
                                        <div class="custella-content-row-input col">
                                            <span class="custella-content-row-input-title" id="label_TaskEndTime">{{ translate?.task.fields.endTime.singular }}</span>
                                            <span class="p-input-icon-right w-100">
                                                <i class="pi pi-clock" style="z-index: 1;"  (click)="openEndTime()"></i>
                                                <p-calendar  #endTime hourFormat="12" [placeholder]="translate?.general.messages.none" id="picklist_TaskEndTimeField" [timeOnly]="true" [(ngModel)]="addTask.endTime" formControlName="endTime" name="endTime" appendTo="body"></p-calendar>
                                              
                                            </span>
                                           
                                        </div>
                                    </ng-container>
                                    
                                </div>

                            </div>
                        </div>
                        <!-- my focus ends here -->

                        <div class="custella-content-row pe-0">  
                            <div class="custella-content-row-input col-12">
                                <span class="custella-content-row-input-title" id="label_TaskDesc" >{{ translate?.task.fields.description.singular }} </span>
                                <textarea pInputTextarea autocomplete="off"id="input_TaskDescField" rows="3" class="mt-2" formControlName="description" [(ngModel)]="addTask.description" name="description" [maxlength]="320000"></textarea>
                            </div>
                        </div>
                    </div>

                    <!-- show more details -->

  
                <div class="custella-form-container-footer mb-0">
                    <div class="d-flex align-items-center justify-content-end">

                        <ng-container >
  
                              <button
                                class="custella-btn-white ms-2 text-12"
                                [disabled]="submitTouched"
                                type="button"
                                *ngIf="mode === 'add'"
                                (click)="onSubmit()"
                                id="btn_TaskCreate"
                                translate >
                                {{ translate?.general.buttons.create.singular }}
                            </button>
                            <button
                                class="custella-btn-white ms-2 text-12"
                                [disabled]="submitTouched || addTask.adhoc"
                                type="button"
                                *ngIf="mode === 'edit'"
                                (click)="onSubmit()"
                                id="btn_TaskUpdate"
                                translate >
                                {{ translate?.general.buttons.save.singular }}
                            </button>
                           
                        </ng-container>
                       
  
                    </div>
                </div>
            </div>
        </div>
    </form>
  </div>
  